<template>
  <div class="expand-container">
    <header @click="toggleContent()" v-bind:class="{ opened: showContent }">
      <slot name="header"></slot>
      <div class="toggle-chevron"></div>
    </header>

    <main>
      <div class="content" v-if="showContent">
        <slot />
      </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'ExpandText',
  data: () => ({
    showContent: false,
  }),
  methods: {
    toggleContent() {
      this.showContent = !this.showContent;
    },
  },
};
</script>

<style lang="less" scoped>
  .expand-container {
    header {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      margin: 17px 0;
      cursor: pointer;
      color: #ddd;

      .toggle-chevron {
        width: 12px;
        height: 8px;
        background: url('../../assets/images/chevron.png') 0 0 no-repeat;
        transition: .4s;
      }

      &.opened .toggle-chevron {
        transform: rotateX(180deg);
      }
    }

    main {
      display: block;
      color: #7c7c7c;
      border-bottom: 1px solid #4d4d4d;
      line-height: 24px;

      .content {
        padding-bottom: 17px;
        text-align: left;

        p {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
